angular.module('impactx.catalog').controller('ProductCodingImportController', [
    '$scope',
    'dataGen',
    'ToastService',
    '$mdDialog',
    'TranslationService',
    ProductCodingImportController
]);

function ProductCodingImportController($scope, dataGen, ToastService, $mdDialog, TranslationService) {
    var ctrl = this;

    $scope.uploadFile = {};
    $scope.cancelLabel = TranslationService.get("abort");
    
    ctrl.import = function () {
        $scope.uploadInProgress = true;
        var paramObj = {
            file: $scope.uploadFile.file
        };
        dataGen.uploadFile(paramObj, "/productcoding/import", true).then(function () {
            $scope.uploadInProgress = false;
            $mdDialog.hide();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        }, function () {
            $scope.uploadInProgress = false;
        });
    };

    ctrl.cancel = function () {
        $mdDialog.cancel();
    }

}